import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

export const usePricingRules = (productId) => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getToken } = useAuth();

  const fetchRules = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pricing/products/${productId}/rules`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRules(response.data);
    } catch (error) {
      console.error('خطا در دریافت قوانین قیمت‌گذاری:', error);
      toast.error('خطا در دریافت قوانین قیمت‌گذاری');
    } finally {
      setLoading(false);
    }
  };

  const addRule = async (ruleData) => {
    try {
      console.log('Adding rule with data:', ruleData);
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/pricing/rules`,
        {
          ...ruleData,
          product_id: productId,
          threshold_direction: ruleData.threshold_direction || 'below'  // اضافه کردن مقدار پیش‌فرض
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRules(prev => [...prev, response.data]);
      toast.success('قانون جدید با موفقیت اضافه شد');
      return response.data;
    } catch (error) {
      console.error('خطا در افزودن قانون:', error);
      toast.error('خطا در افزودن قانون');
      throw error;
    }
  };

  const updateRule = async (ruleId, ruleData) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/pricing/rules/${ruleId}`,
        { ...ruleData, product_id: productId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRules(prev => prev.map(rule => rule.id === ruleId ? response.data : rule));
      toast.success('قانون با موفقیت به‌روزرسانی شد');
      return response.data;
    } catch (error) {
      console.error('خطا در به‌روزرسانی قانون:', error);
      toast.error('خطا در به‌روزرسانی قانون');
      throw error;
    }
  };

  const toggleRule = async (ruleId) => {
    try {
      const token = getToken();
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/pricing/rules/${ruleId}/toggle`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRules(prev => prev.map(rule => 
        rule.id === ruleId ? { ...rule, is_active: response.data.is_active } : rule
      ));
      toast.success('وضعیت قانون با موفقیت تغییر کرد');
    } catch (error) {
      console.error('خطا در تغییر وضعیت قانون:', error);
      toast.error('خطا در تغییر وضعیت قانون');
    }
  };

  const deleteRule = async (ruleId) => {
    try {
      const token = getToken();
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/pricing/rules/${ruleId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRules(prev => prev.filter(rule => rule.id !== ruleId));
      toast.success('قانون با موفقیت حذف شد');
    } catch (error) {
      console.error('خطا در حذف قانون:', error);
      toast.error('خطا در حذف قانون');
    }
  };

  useEffect(() => {
    if (productId) {
      fetchRules();
    }
  }, [productId]);

  return {
    rules,
    loading,
    addRule,
    updateRule,
    toggleRule,
    deleteRule,
    fetchRules
  };
};
